import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Flex, Heading } from "@chakra-ui/react";

/* Import images */
import SpaceImage from "../../Assets/Images/cover-space.jpg";
import AerospaceImage from "../../Assets/Images/cover-aerospace.jpg";
import DefenceImage from "../../Assets/Images/defence.jpg";
import F1Image from "../../Assets/Images/formula1.jpg";
import OilAndGasImage from "../../Assets/Images/oil-and-gas.jpg";
import PowerImage from "../../Assets/Images/power.jpg";

const SectorsCarousel = () => {
  return (
    <Carousel interval={3000}>
      <Carousel.Item>
        <Flex
          flex="1"
          backgroundImage={SpaceImage}
          height="400px"
          backgroundPosition="center"
          backgroundSize="cover"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex padding="10px">
            <Heading size="2xl" color="brand.white">
              Space
            </Heading>
          </Flex>
        </Flex>
      </Carousel.Item>
      <Carousel.Item>
        <Flex
          flex="1"
          backgroundImage={AerospaceImage}
          height="400px"
          backgroundPosition="center"
          backgroundSize="cover"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex padding="10px">
            <Heading size="2xl" color="brand.white">
              Aerospace
            </Heading>
          </Flex>
        </Flex>
      </Carousel.Item>
      <Carousel.Item>
        <Flex
          flex="1"
          backgroundImage={F1Image}
          height="400px"
          backgroundPosition="center"
          backgroundSize="cover"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex padding="10px">
            <Heading size="2xl" color="brand.white">
              F1
            </Heading>
          </Flex>
        </Flex>
      </Carousel.Item>
      <Carousel.Item>
        <Flex
          flex="1"
          backgroundImage={OilAndGasImage}
          height="400px"
          backgroundPosition="center"
          backgroundSize="cover"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex padding="10px">
            <Heading size="2xl" color="brand.white">
              Oil & Gas
            </Heading>
          </Flex>
        </Flex>
      </Carousel.Item>
      <Carousel.Item>
        <Flex
          flex="1"
          backgroundImage={PowerImage}
          height="400px"
          backgroundPosition="center"
          backgroundSize="cover"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Flex padding="10px">
            <Heading size="2xl" color="brand.white">
              Power
            </Heading>
          </Flex>
        </Flex>
      </Carousel.Item>
    </Carousel>
  );
};

export default SectorsCarousel;
